import * as joint from '@clientio/rappid';

export class PortsService {
  static addPorts(element: joint.dia.Element) {
    element.prop('ports/groups', {
      left: {
        position: {
          name: 'left',
        },
        attrs: {
          portLeft: {
            magnet: true,
            r: 8,
            fill: '#023047',
            stroke: '#023047',
            opacity: 0.2,
            visibility: 'hidden',
          },
        },
        markup: [
          {
            tagName: 'circle',
            selector: 'portLeft',
          },
        ],
      },
      right: {
        position: {
          name: 'right',
        },
        attrs: {
          portRight: {
            magnet: true,
            r: 8,
            fill: '#023047',
            stroke: '#023047',
            opacity: 0.2,
            visibility: 'hidden',
          },
        },
        markup: [
          {
            tagName: 'circle',
            selector: 'portRight',
          },
        ],
      },
      top: {
        position: {
          name: 'top',
        },
        attrs: {
          portTop: {
            magnet: true,
            r: 8,
            fill: '#023047',
            stroke: '#023047',
            opacity: 0.2,
            visibility: 'hidden',
          },
        },
        markup: [
          {
            tagName: 'circle',
            selector: 'portTop',
          },
        ],
      },
      bottom: {
        position: {
          name: 'bottom',
        },
        attrs: {
          portBottom: {
            magnet: true,
            r: 8,
            fill: '#023047',
            stroke: '#023047',
            opacity: 0.2,
            visibility: 'hidden',
          },
        },
        markup: [
          {
            tagName: 'circle',
            selector: 'portBottom',
          },
        ],
      },
    });

    element.addPort({ group: 'left' });
    element.addPort({ group: 'right' });
    element.addPort({ group: 'top' });
    element.addPort({ group: 'bottom' });
  }
}
